import React from 'react';
import {Box} from '../box';
import {FrameworkImage} from '../image-renderer';
import {HorizontalDivider} from '../divider/horizontal-divider';
import {VerticalDivider} from '../divider/vertical-divider';
import {Typography} from '../typography';
import {EmailSignupForm, formValues} from '../email-signup-form';
import {VisibilityBox} from '../box/visibility-box';

export interface NFTEmailSignUpProps {
  image?: string | null;
  header?: string | null;
  formText?: string | null;
  apiKey?: string;
  onSignupSubmit: (values: formValues) => void;
}

export const NFTEmailSignUp: React.FC<NFTEmailSignUpProps> = ({
  image,
  header,
  formText,
  apiKey,
  onSignupSubmit,
}: NFTEmailSignUpProps) => {
  return (
    <Box>
      <Box ml={['md', 'lg']} mb={['md', 'lg']} mt="sixteen">
        <Typography color="textDefault" textStyle={['h2', 'h2', 'h1']}>
          {header}
        </Typography>
      </Box>
      <HorizontalDivider />
      <Box flexDirection={['column', 'column', 'row']}>
        <VisibilityBox show={[true, true, false]}>
          <Box flex={0} width="100%" style={{paddingBottom: '100%'}}>
            {image ? (
              <FrameworkImage
                src={image}
                alt="artist banner"
                layout="fill"
                objectFit="cover"
              />
            ) : null}
          </Box>
          <HorizontalDivider />
          <EmailSignupForm
            content1={formText}
            apiKey={apiKey}
            onSignupSubmit={onSignupSubmit}
          />
        </VisibilityBox>
        <VisibilityBox show={[false, false, true]}>
          <Box flex={1} width="auto" style={{paddingBottom: '33%'}}>
            {image ? (
              <FrameworkImage
                src={image}
                alt="artist banner"
                layout="fill"
                objectFit="cover"
              />
            ) : null}
          </Box>
          <VerticalDivider />

          <Box flex={2}>
            <EmailSignupForm
              content1={formText}
              apiKey={apiKey}
              onSignupSubmit={onSignupSubmit}
            />
          </Box>
        </VisibilityBox>
      </Box>
      <HorizontalDivider />
    </Box>
  );
};
